import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../../utils/index.js";
import { CdnIcon } from "../../CdnIcon/index.js";
import { Image } from "../../Image/index.js";
import { Label } from "../../Label/index.js";
import { radioButtonVariants } from "../RadioButton/Radio.variants.js";
import { RadioButton } from "../RadioButton/RadioButton.js";
const textStyleIconSizes = {
    body1: '24',
    body2: '20',
    body3: '16',
    heading4: '24',
    heading5: '20',
    heading6: '16'
};
function RadioWithLabel(props) {
    const { labelClassName, radioButtonClassName, labelProps = {}, labelNode, disabled, emphasis, size = '20', value, iconLeft, textStyle = 'body2', helperText = '', textRight = '', imageSrc = '', maxWidth = 24, height = 6 } = props;
    const { labelSlot, iconSlot, helperSlot, imageSlot, containerSlot, textRightSlot } = radioButtonVariants({
        emphasis,
        size,
        disabled
    });
    const iconSlotClasses = iconSlot();
    const iconSize = textStyleIconSizes[textStyle] ?? '20';
    const labelClasses = cn(labelSlot(), labelClassName);
    const textRightClasses = textRightSlot();
    return /*#__PURE__*/ jsxs(Label, {
        className: labelClasses,
        ...labelProps,
        children: [
            /*#__PURE__*/ jsx(RadioButton, {
                radioButtonClassName: radioButtonClassName,
                disabled: disabled,
                emphasis: emphasis,
                size: size,
                value: value
            }),
            iconLeft && /*#__PURE__*/ jsx(CdnIcon, {
                className: iconSlotClasses,
                iconName: iconLeft,
                size: iconSize
            }),
            /*#__PURE__*/ jsxs("div", {
                className: containerSlot(),
                children: [
                    labelNode,
                    helperText && /*#__PURE__*/ jsx("span", {
                        className: helperSlot(),
                        children: helperText
                    })
                ]
            }),
            imageSrc && /*#__PURE__*/ jsx("div", {
                className: imageSlot(),
                children: /*#__PURE__*/ jsx(Image, {
                    src: imageSrc,
                    alt: "image",
                    maxWidth: maxWidth,
                    height: height,
                    objectFit: "contain",
                    objectPosition: "center"
                })
            }),
            textRight && /*#__PURE__*/ jsxs("span", {
                className: textRightClasses,
                children: [
                    "(",
                    textRight,
                    ")"
                ]
            })
        ]
    });
}
export { RadioWithLabel };
